import { getLogger as baseGetLogger } from '@logtape/logtape';

export function getLogger(context?: string) {
  const logger = baseGetLogger(context ? ['app', context] : ['app']);

  return {
    error(message: string, meta?: any, error?: unknown) {
      logger.error({ ...meta, error }, message);
    },

    info(message: string, meta?: any) {
      logger.info(meta ?? {}, message);
    },

    warn(message: string, meta?: any) {
      logger.warn(meta ?? {}, message);
    },

    debug(message: string, meta?: any) {
      logger.debug(meta ?? {}, message);
    },
  };
}
